(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nf-benefits-accordion"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nf-benefits-accordion')) {
    customElements.define(
      'nf-benefits-accordion',
      class NfBenefitsAccordion extends HTMLElement {
        connectedCallback() {
          if (this._onToggle) return;

          this._onToggle = (event) => {
            const opened = event.target;
            if (!(opened instanceof HTMLDetailsElement)) return;
            /* Mode « Grande image » : à la fermeture, l'image suit une ligne restée ouverte ; si tout est fermé, la dernière image reste affichée */
            if (!opened.open) {
              const stillOpen = this.querySelector('details[open]');
              if (stillOpen) this._activate(stillOpen.dataset.block);
              return;
            }
            /* La ligne ouverte affiche son image */
            this._activate(opened.dataset.block);
            if (!this.hasAttribute('data-single-open')) return;
            this.querySelectorAll('details[open]').forEach((item) => {
              if (item !== opened) item.open = false;
            });
          };
          /* « toggle » ne remonte pas : écoute en phase de capture */
          this.addEventListener('toggle', this._onToggle, true);

          /* Une ligne sans texte ne s'ouvre pas (clic, Entrée ou Espace) */
          this._onClick = (event) => {
            const summary = event.target instanceof Element ? event.target.closest('summary') : null;
            if (!summary || !this.contains(summary)) return;
            const item = summary.parentElement;
            if (item && item.classList.contains('nf-benefits-accordion__item--static')) event.preventDefault();
          };
          this.addEventListener('click', this._onClick);

          /* Éditeur de thème : ouvrir la ligne sélectionnée dans la colonne de gauche et afficher son image */
          this._onBlockSelect = (event) => {
            const item = event.target instanceof Element ? event.target.closest('details') : null;
            if (!item || !this.contains(item)) return;
            this._activate(item.dataset.block);
            if (item.classList.contains('nf-benefits-accordion__item--static')) return;
            item.open = true;
          };
          this.addEventListener('shopify:block:select', this._onBlockSelect);
        }

        /* Affiche l'image de la ligne indiquée ; une ligne sans image garde l'image déjà affichée */
        _activate(id) {
          if (!id) return;
          const slides = Array.from(this.querySelectorAll('.nf-benefits-accordion__slide'));
          const target = slides.find((slide) => slide.dataset.block === id);
          if (!target) return;
          slides.forEach((slide) => slide.classList.toggle('is-active', slide === target));
        }

        disconnectedCallback() {
          if (this._onToggle) this.removeEventListener('toggle', this._onToggle, true);
          if (this._onClick) this.removeEventListener('click', this._onClick);
          if (this._onBlockSelect) this.removeEventListener('shopify:block:select', this._onBlockSelect);
          this._onToggle = null;
          this._onClick = null;
          this._onBlockSelect = null;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nf-countdown-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nf-countdown')) {
    class NFCountdown extends HTMLElement {
      static get observedAttributes() {
        return ['data-show-timer', 'data-mode', 'data-duration', 'data-end', 'data-expired', 'data-sticky'];
      }

      connectedCallback() {
        this._start();
      }

      disconnectedCallback() {
        this._stop();
      }

      attributeChangedCallback(name, oldValue, newValue) {
        if (!this._started || oldValue === newValue) return;
        this._stop();
        this._start();
      }

      _start() {
        this._started = true;
        this._designMode = this.dataset.designMode === 'true';
        this._setupSticky();

        if (this.dataset.showTimer !== 'true') {
          this.hidden = false;
          return;
        }

        this._mode = this.dataset.mode === 'fixed' ? 'fixed' : 'evergreen';
        this._behavior = this.dataset.expired || 'restart';
        this._durationMs = Math.max(1, parseInt(this.dataset.duration, 10) || 120) * 60000;
        this._key = 'nf-countdown:' + (this.dataset.sectionId || 'default') + ':' + (parseInt(this.dataset.duration, 10) || 120);
        this._end = this._mode === 'fixed' ? this._parseEnd(this.dataset.end) : this._readEvergreenEnd();

        this._onVisibility = () => {
          if (!document.hidden) this._tick();
        };
        document.addEventListener('visibilitychange', this._onVisibility);

        if (this._tick()) {
          this._interval = window.setInterval(() => this._tick(), 1000);
        }
      }

      _stop() {
        this._started = false;
        if (this._interval) {
          window.clearInterval(this._interval);
          this._interval = null;
        }
        if (this._onVisibility) {
          document.removeEventListener('visibilitychange', this._onVisibility);
          this._onVisibility = null;
        }
        if (this._resizeObserver) {
          this._resizeObserver.disconnect();
          this._resizeObserver = null;
        }
        if (this._ownsHeightVar) {
          document.body.style.removeProperty('--nf-cbar-height');
          this._ownsHeightVar = false;
        }
      }

      /* Date de fin fixe « AAAA-MM-JJ HH:MM », interprétée dans le fuseau du navigateur. */
      _parseEnd(value) {
        const match = /^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?$/.exec((value || '').trim());
        if (!match) return 0;
        const time = new Date(+match[1], +match[2] - 1, +match[3], +(match[4] || 0), +(match[5] || 0), 0).getTime();
        return isNaN(time) ? 0 : time;
      }

      _storageGet() {
        try {
          return window.localStorage.getItem(this._key);
        } catch (error) {
          return null;
        }
      }

      _storageSet(value) {
        try {
          window.localStorage.setItem(this._key, String(value));
        } catch (error) {
          /* Stockage indisponible (navigation privée, blocage) : le compteur vit le temps de la page. */
        }
      }

      _readEvergreenEnd() {
        const now = Date.now();
        const stored = parseInt(this._storageGet(), 10);
        /* Valeur absente, illisible ou incohérente (plus loin dans le futur que la durée) : on repart de zéro. */
        if (isNaN(stored) || stored - now > this._durationMs) {
          return this._restart();
        }
        return stored;
      }

      _restart() {
        const end = Date.now() + this._durationMs;
        this._storageSet(end);
        return end;
      }

      _tick() {
        let remaining = this._end - Date.now();

        if (remaining <= 0) {
          if (this._mode === 'evergreen' && this._behavior === 'restart') {
            this._end = this._restart();
            remaining = this._end - Date.now();
          } else {
            this._expire();
            return false;
          }
        }

        const timer = this.querySelector('.nf-cbar__timer');
        if (timer && timer.hidden) timer.hidden = false;
        if (this.hidden) {
          this.hidden = false;
          this._syncHeaderGroupHeight();
        }

        const total = Math.max(0, Math.floor(remaining / 1000));
        this._render('h', Math.floor(total / 3600));
        this._render('m', Math.floor((total % 3600) / 60));
        this._render('s', total % 60);
        return true;
      }

      _render(unit, value) {
        /* Jamais de valeur négative ; on relit le DOM car Horizon peut re-rendre (morph) la section. */
        const text = String(Math.max(0, value)).padStart(2, '0');
        const node = this.querySelector('[data-nf-unit="' + unit + '"]');
        if (node && node.textContent !== text) node.textContent = text;
      }

      _expire() {
        if (this._interval) {
          window.clearInterval(this._interval);
          this._interval = null;
        }
        this._render('h', 0);
        this._render('m', 0);
        this._render('s', 0);

        const timer = this.querySelector('.nf-cbar__timer');
        /* Dans l'éditeur de thème, on ne masque jamais toute la barre (elle doit rester modifiable). */
        if (this._behavior === 'hide_bar' && !this._designMode) {
          this.hidden = true;
          this._syncHeaderGroupHeight();
        } else if (timer) {
          timer.hidden = true;
        }
      }

      /*
        Horizon ne recalcule --header-group-height qu'au chargement (assets/critical.js). Quand la barre se masque ou
        réapparaît en cours de visite, on refait le même calcul pour que les éléments qui en dépendent restent justes.
      */
      _syncHeaderGroupHeight() {
        const group = this.closest('#header-group');
        if (!group) return;
        let total = 0;
        for (const child of Array.from(group.children)) {
          if (child instanceof HTMLElement) total += child.offsetHeight;
        }
        const header = document.querySelector('#header-component');
        if (
          header instanceof HTMLElement &&
          header.hasAttribute('transparent') &&
          header.parentElement &&
          header.parentElement.nextElementSibling
        ) {
          total += header.offsetHeight;
        }
        document.body.style.setProperty('--header-group-height', total + 'px');
      }

      _setupSticky() {
        if (this.dataset.sticky !== 'true' || typeof ResizeObserver === 'undefined') return;
        this._ownsHeightVar = true;
        const update = () => {
          const height = this.hidden ? 0 : this.getBoundingClientRect().height;
          document.body.style.setProperty('--nf-cbar-height', height + 'px');
        };
        this._resizeObserver = new ResizeObserver(update);
        this._resizeObserver.observe(this);
        update();
      }
    }

    customElements.define('nf-countdown', NFCountdown);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nf-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nf-faq')) {
    customElements.define(
      'nf-faq',
      class NfFaq extends HTMLElement {
        connectedCallback() {
          if (this._onToggle) return;
          this._onToggle = (event) => {
            const opened = event.target;
            if (!this.hasAttribute('data-single-open')) return;
            if (!(opened instanceof HTMLDetailsElement) || !opened.open) return;
            this.querySelectorAll('details[open]').forEach((item) => {
              if (item !== opened) item.open = false;
            });
          };
          /* « toggle » ne remonte pas : écoute en phase de capture */
          this.addEventListener('toggle', this._onToggle, true);
        }

        disconnectedCallback() {
          if (!this._onToggle) return;
          this.removeEventListener('toggle', this._onToggle, true);
          this._onToggle = null;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nf-ingredients"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nf-ingredients-carousel')) {
    class NfIngredientsCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-nf-track]');
        if (!this.track) return;

        this.ticking = false;
        this.onScroll = this.onScroll.bind(this);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });

        /* Éditeur de thème : amener la carte sélectionnée dans le champ du carrousel. */
        this.onBlockSelect = this.onBlockSelect.bind(this);
        this.addEventListener('shopify:block:select', this.onBlockSelect);

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.onScroll);
          this.resizeObserver.observe(this.track);
        }
        this.update();
      }

      disconnectedCallback() {
        if (this.track && this.onScroll) this.track.removeEventListener('scroll', this.onScroll);
        if (this.resizeObserver) this.resizeObserver.disconnect();
        this.resizeObserver = null;
        if (this.onBlockSelect) this.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      onBlockSelect(event) {
        const slide = event.target instanceof Element ? event.target.closest('[data-nf-slide]') : null;
        if (!slide || !this.track || this.track.scrollWidth - this.track.clientWidth <= 2) return;
        const gutter = parseFloat(window.getComputedStyle(this.track).paddingLeft) || 0;
        const delta = slide.getBoundingClientRect().left - this.track.getBoundingClientRect().left - gutter;
        this.track.scrollBy({ left: delta, behavior: 'auto' });
      }

      onScroll() {
        if (this.ticking) return;
        this.ticking = true;
        window.requestAnimationFrame(() => {
          this.ticking = false;
          this.update();
        });
      }

      update() {
        if (!this.track || !this.track.isConnected) return;

        const max = this.track.scrollWidth - this.track.clientWidth;

        /* Zone défilante (mobile) : accessible au clavier ; sinon aucun arrêt de tabulation inutile. */
        if (max > 2) {
          this.track.setAttribute('tabindex', '0');
        } else {
          this.track.removeAttribute('tabindex');
        }

        const slides = Array.from(this.track.querySelectorAll('[data-nf-slide]'));
        const dots = Array.from(this.querySelectorAll('[data-nf-dot]'));
        if (!slides.length || !dots.length) return;

        let active = 0;

        if (max > 0 && this.track.scrollLeft >= max - 2) {
          active = slides.length - 1;
        } else {
          const origin = this.track.getBoundingClientRect().left;
          let best = Infinity;
          slides.forEach((slide, index) => {
            const distance = Math.abs(slide.getBoundingClientRect().left - origin);
            if (distance < best) {
              best = distance;
              active = index;
            }
          });
        }

        dots.forEach((dot, index) => dot.classList.toggle('is-active', index === active));
      }
    }

    customElements.define('nf-ingredients-carousel', NfIngredientsCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nf-reasons"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nf-reasons-carousel')) {
    class NfReasonsCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-nf-track]');
        if (!this.track) return;

        this.ticking = false;
        this.onScroll = this.onScroll.bind(this);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });

        /* Éditeur de thème : amener la carte sélectionnée dans le champ du carrousel. */
        this.onBlockSelect = this.onBlockSelect.bind(this);
        this.addEventListener('shopify:block:select', this.onBlockSelect);

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.onScroll);
          this.resizeObserver.observe(this.track);
        }
        this.update();
      }

      disconnectedCallback() {
        if (this.track && this.onScroll) this.track.removeEventListener('scroll', this.onScroll);
        if (this.resizeObserver) this.resizeObserver.disconnect();
        this.resizeObserver = null;
        if (this.onBlockSelect) this.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      onBlockSelect(event) {
        const slide = event.target instanceof Element ? event.target.closest('[data-nf-slide]') : null;
        if (!slide || !this.track || this.track.scrollWidth - this.track.clientWidth <= 2) return;
        const gutter = parseFloat(window.getComputedStyle(this.track).paddingLeft) || 0;
        const delta = slide.getBoundingClientRect().left - this.track.getBoundingClientRect().left - gutter;
        this.track.scrollBy({ left: delta, behavior: 'auto' });
      }

      onScroll() {
        if (this.ticking) return;
        this.ticking = true;
        window.requestAnimationFrame(() => {
          this.ticking = false;
          this.update();
        });
      }

      update() {
        if (!this.track || !this.track.isConnected) return;

        const max = this.track.scrollWidth - this.track.clientWidth;

        /* Zone défilante (mobile) : accessible au clavier ; sinon aucun arrêt de tabulation inutile. */
        if (max > 2) {
          this.track.setAttribute('tabindex', '0');
        } else {
          this.track.removeAttribute('tabindex');
        }

        const slides = Array.from(this.track.querySelectorAll('[data-nf-slide]'));
        const dots = Array.from(this.querySelectorAll('[data-nf-dot]'));
        if (!slides.length || !dots.length) return;

        let active = 0;

        if (max > 0 && this.track.scrollLeft >= max - 2) {
          active = slides.length - 1;
        } else {
          const origin = this.track.getBoundingClientRect().left;
          let best = Infinity;
          slides.forEach((slide, index) => {
            const distance = Math.abs(slide.getBoundingClientRect().left - origin);
            if (distance < best) {
              best = distance;
              active = index;
            }
          });
        }

        dots.forEach((dot, index) => dot.classList.toggle('is-active', index === active));
      }
    }

    customElements.define('nf-reasons-carousel', NfReasonsCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nf-stats"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nf-stat-number')) {
    class NfStatNumber extends HTMLElement {
      connectedCallback() {
        if (this._nfDone || this._nfObserver) return;
        if (this.dataset.animate !== 'true') return;
        if (!('IntersectionObserver' in window) || !('requestAnimationFrame' in window)) return;
        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        const finalText = (this.textContent || '').trim();
        const compact = finalText.replace(/[\s   ]/g, '');
        if (!/^\d+([.,]\d+)?$/.test(compact)) return;

        const parts = compact.split(/[.,]/);
        const decimals = parts.length > 1 ? parts[1].length : 0;
        const target = parseFloat(compact.replace(',', '.'));
        if (!isFinite(target) || target <= 0) return;

        this._nfFinal = finalText;
        this._nfTarget = target;
        this._nfDuration = Math.max(200, parseInt(this.dataset.duration, 10) || 1600);
        this._nfFormat = new Intl.NumberFormat('fr-FR', {
          minimumFractionDigits: decimals,
          maximumFractionDigits: decimals,
          useGrouping: compact !== finalText,
        });

        /* Réserve la largeur finale pour éviter tout saut de mise en page. */
        const width = this.offsetWidth;
        if (width > 0) this.style.minWidth = width + 'px';
        this.textContent = this._nfFormat.format(0);

        this._nfObserver = new IntersectionObserver(
          (entries) => {
            if (entries.some((entry) => entry.isIntersecting)) {
              this._nfStopObserving();
              this._nfRun();
            }
          },
          { threshold: 0.4 }
        );
        this._nfObserver.observe(this);
      }

      disconnectedCallback() {
        this._nfStopObserving();
        if (this._nfFrame) cancelAnimationFrame(this._nfFrame);
        this._nfFinish();
      }

      _nfStopObserving() {
        if (this._nfObserver) {
          this._nfObserver.disconnect();
          this._nfObserver = null;
        }
      }

      _nfRun() {
        const start = performance.now();
        const step = (now) => {
          const progress = Math.min(1, (now - start) / this._nfDuration);
          const eased = 1 - Math.pow(1 - progress, 3);
          if (progress < 1) {
            this.textContent = this._nfFormat.format(this._nfTarget * eased);
            this._nfFrame = requestAnimationFrame(step);
          } else {
            this._nfFinish();
          }
        };
        this._nfFrame = requestAnimationFrame(step);
      }

      _nfFinish() {
        this._nfFrame = null;
        if (this._nfFinal != null) {
          this.textContent = this._nfFinal;
          this._nfFinal = null;
          this._nfDone = true;
        }
        this.style.minWidth = '';
      }
    }

    customElements.define('nf-stat-number', NfStatNumber);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nf-timeline"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nf-timeline-steps')) {
    class NfTimelineSteps extends HTMLElement {
      connectedCallback() {
        if (this.dataset.animate !== 'true') return;
        if (!('IntersectionObserver' in window)) return;

        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        if (this.motionQuery.matches) return;

        this.list = this.querySelector('.nf-timeline__list');
        if (!this.list || this.list.children.length < 2) return;

        this.ticking = false;
        this.listening = false;
        this.onScroll = this.onScroll.bind(this);
        this.measure = this.measure.bind(this);
        this.onMotionChange = this.onMotionChange.bind(this);

        this.enhanced = true;
        this.classList.add('is-enhanced');
        this.measure();

        this.intersection = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.startListening();
                this.update();
              } else {
                this.stopListening();
                this.update();
              }
            });
          },
          { rootMargin: '20% 0px 20% 0px' }
        );
        this.intersection.observe(this);

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.measure);
          this.resizeObserver.observe(this);
        }

        if (this.motionQuery.addEventListener) {
          this.motionQuery.addEventListener('change', this.onMotionChange);
        }
      }

      disconnectedCallback() {
        this.stopListening();
        if (this.intersection) this.intersection.disconnect();
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.motionQuery && this.motionQuery.removeEventListener) {
          this.motionQuery.removeEventListener('change', this.onMotionChange);
        }
        this.intersection = null;
        this.resizeObserver = null;
        this.enhanced = false;
      }

      onMotionChange(event) {
        if (!event.matches) return;
        /* L'utilisateur vient de demander moins d'animations : on affiche l'état final. */
        this.stopListening();
        if (this.intersection) this.intersection.disconnect();
        if (this.resizeObserver) this.resizeObserver.disconnect();
        this.enhanced = false;
        this.classList.remove('is-enhanced');
      }

      startListening() {
        if (this.listening) return;
        this.listening = true;
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
      }

      stopListening() {
        if (!this.listening) return;
        this.listening = false;
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
      }

      onScroll() {
        if (this.ticking) return;
        this.ticking = true;
        window.requestAnimationFrame(() => {
          this.ticking = false;
          this.update();
        });
      }

      /* Positions des centres de puces, relatives au haut du composant. */
      measure() {
        if (!this.list) return;
        const hostTop = this.getBoundingClientRect().top;
        this.steps = Array.from(this.list.children);
        this.centers = this.steps.map((step) => {
          const marker = step.querySelector('.nf-timeline__marker');
          if (!marker) return 0;
          const rect = marker.getBoundingClientRect();
          return rect.top + rect.height / 2 - hostTop;
        });
        this.start = this.centers[0];
        this.total = Math.max(this.centers[this.centers.length - 1] - this.start, 0);
        this.style.setProperty('--nf-tl-fill-top', this.start + 'px');
        this.style.setProperty('--nf-tl-fill-height', this.total + 'px');
        this.update();
      }

      update() {
        if (!this.steps || !this.steps.length || !this.enhanced) return;

        /* Un re-rendu par « morph » peut effacer la classe et les variables posées par le JS : on les rétablit. */
        if (!this.classList.contains('is-enhanced')) {
          this.classList.add('is-enhanced');
          this.style.setProperty('--nf-tl-fill-top', this.start + 'px');
          this.style.setProperty('--nf-tl-fill-height', this.total + 'px');
        }

        const viewport = window.innerHeight || document.documentElement.clientHeight;
        const trigger = viewport * 0.62;
        const hostTop = this.getBoundingClientRect().top;
        let reached = trigger - (hostTop + this.start);

        /* Bas de page atteint : la frise ne pourra pas défiler plus loin, on la termine. */
        const doc = document.documentElement;
        if (window.scrollY + viewport >= doc.scrollHeight - 2 && hostTop < viewport) {
          reached = this.total;
        }

        const filled = Math.min(Math.max(reached, 0), this.total);
        const ratio = this.total > 0 ? filled / this.total : 0;
        this.style.setProperty('--nf-tl-progress', ratio.toFixed(4));

        this.steps.forEach((step, index) => {
          const threshold = this.centers[index] - this.start;
          step.classList.toggle('is-active', reached >= threshold - 1);
        });
      }
    }

    customElements.define('nf-timeline-steps', NfTimelineSteps);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nf-video-stories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nf-video-stories')) {
    class NfVideoStories extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-nf-track]');
        if (!this.track) return;

        this.ticking = false;
        this.onClick = this.onClick.bind(this);
        this.onMedia = this.onMedia.bind(this);
        this.onScroll = this.onScroll.bind(this);
        this.onBlockSelect = this.onBlockSelect.bind(this);

        this.addEventListener('click', this.onClick);
        /* Les événements média ne remontent pas : on les écoute en phase de capture. */
        ['play', 'playing', 'pause', 'ended'].forEach((type) => this.addEventListener(type, this.onMedia, true));
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.onScroll);
          this.resizeObserver.observe(this.track);
        }

        /* Pause quand la carte sort de l'écran (ou du carrousel). */
        if ('IntersectionObserver' in window) {
          this.visibility = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.intersectionRatio >= 0.5) return;
                /* Carte plus haute que l'écran : on ne coupe que si elle occupe moins de la moitié de la fenêtre. */
                if (entry.intersectionRect.height >= window.innerHeight * 0.5) return;
                const video = entry.target.querySelector('video');
                if (video && !video.paused) video.pause();
              });
            },
            { threshold: [0, 0.5] }
          );
          this.track.querySelectorAll('[data-nf-slide]').forEach((slide) => this.visibility.observe(slide));
        }

        this.update();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        ['play', 'playing', 'pause', 'ended'].forEach((type) => this.removeEventListener(type, this.onMedia, true));
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        if (this.track) this.track.removeEventListener('scroll', this.onScroll);
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.visibility) this.visibility.disconnect();
        this.resizeObserver = null;
        this.visibility = null;
        this.querySelectorAll('video').forEach((video) => video.pause());
      }

      get reducedMotion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      onClick(event) {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;

        const play = target.closest('[data-nf-play]');
        if (play) {
          this.toggle(play.closest('[data-nf-slide]'));
          return;
        }

        if (target.closest('[data-nf-prev]')) this.scrollByPage(-1);
        if (target.closest('[data-nf-next]')) this.scrollByPage(1);
      }

      toggle(card) {
        const video = card ? card.querySelector('video') : null;
        if (!video) return;

        if (!video.paused && !video.ended) {
          video.pause();
          return;
        }

        /* Une seule vidéo à la fois, sur toute la page. */
        document.querySelectorAll('.nf-vs__video').forEach((other) => {
          if (other !== video && !other.paused) other.pause();
        });

        video.muted = false;
        const attempt = video.play();
        if (attempt && typeof attempt.catch === 'function') {
          attempt.catch(() => this.sync(card));
        }
      }

      onMedia(event) {
        const video = event.target;
        if (!(video instanceof HTMLVideoElement)) return;
        if (event.type === 'ended' && !video.loop) {
          try {
            video.currentTime = 0;
          } catch (error) {
            /* Sans conséquence : l'affiche repasse devant la vidéo. */
          }
        }
        this.sync(video.closest('[data-nf-slide]'));
      }

      sync(card) {
        if (!card) return;
        const video = card.querySelector('video');
        const button = card.querySelector('[data-nf-play]');
        if (!video) return;

        const playing = !video.paused && !video.ended;
        card.classList.toggle('is-playing', playing);
        if (this.closest('.nf-vs--controls')) video.controls = playing;

        if (button) {
          const label = playing ? button.dataset.labelPause : button.dataset.labelPlay;
          if (label) button.setAttribute('aria-label', label);
        }
      }

      scrollByPage(direction) {
        if (!this.track) return;
        const slide = this.track.querySelector('[data-nf-slide]');
        const gap = parseFloat(window.getComputedStyle(this.track).columnGap) || 0;
        const step = slide ? slide.getBoundingClientRect().width + gap : this.track.clientWidth * 0.8;
        const visible = Math.max(Math.floor((this.track.clientWidth + gap) / step), 1);
        this.track.scrollBy({
          left: direction * step * visible,
          behavior: this.reducedMotion ? 'auto' : 'smooth',
        });
      }

      onBlockSelect(event) {
        const slide = event.target instanceof Element ? event.target.closest('[data-nf-slide]') : null;
        if (!slide || !this.track || this.track.scrollWidth - this.track.clientWidth <= 2) return;
        const gutter = parseFloat(window.getComputedStyle(this.track).paddingLeft) || 0;
        const delta = slide.getBoundingClientRect().left - this.track.getBoundingClientRect().left - gutter;
        this.track.scrollBy({ left: delta, behavior: 'auto' });
      }

      onScroll() {
        if (this.ticking) return;
        this.ticking = true;
        window.requestAnimationFrame(() => {
          this.ticking = false;
          this.update();
        });
      }

      update() {
        if (!this.track || !this.track.isConnected) return;

        const max = this.track.scrollWidth - this.track.clientWidth;
        const overflowing = max > 2;

        if (overflowing) {
          this.track.setAttribute('tabindex', '0');
        } else {
          this.track.removeAttribute('tabindex');
        }

        const nav = this.querySelector('[data-nf-nav]');
        if (!nav) return;
        nav.hidden = !overflowing;

        const prev = nav.querySelector('[data-nf-prev]');
        const next = nav.querySelector('[data-nf-next]');
        if (prev) prev.disabled = this.track.scrollLeft <= 2;
        if (next) next.disabled = this.track.scrollLeft >= max - 2;
      }
    }

    customElements.define('nf-video-stories', NfVideoStories);
  }

  } catch(e) { console.error(e); }
})();
})();
